export const downloadBlobFile = (data, filename, fileType = 'csv') => {
  const mimeTypes = {
    csv: 'text/csv',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    pdf: 'application/pdf',
    json: 'application/json',
  };

  const type = mimeTypes[fileType.toLowerCase()] || 'application/octet-stream';
  const blob = data instanceof Blob ? data : new Blob([data], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  // Appends extension if not already present in filename
  const fullFilename = filename.endsWith(`.${fileType}`) ? filename : `${filename}.${fileType}`;
  
  link.href = url;
  link.setAttribute('download', fullFilename);
  document.body.appendChild(link);
  link.click();
  
  // Cleanup DOM
  link.remove();
  window.URL.revokeObjectURL(url);
};